import React, { useContext, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { ShopContext } from '../../data/shop/ShopConf';
import { classIf, getAmountInCent, getConfiguration, getLocaleDotRound, getPrintableAmount, getValidAmountString, selectInputText } from '../../data/utils';
import { getLabel } from '../../InitData';
import BetOptionsSection from './BetOptionsSection';

// calc buttons
const BUTTONS_FIRST_ROW = [1, 2, 3, 4, 5];
const BUTTON_SECOND_ROW = [6, 7, 8, 9, 0];

function AmountBetslipForm(props) {
	const betslipContext = useContext(BetslipContext) ;
	const shopContext = useContext(ShopContext);
	const betslipData = betslipContext.getBetslipData();
	const conf = getConfiguration();
	const mult = conf.cs.m;
	const nDec = conf.cs.nd;
	const charDecimalBrowser = getLocaleDotRound().round;
	const charThousandBrowser = getLocaleDotRound().dot;
	const linkedElement = props.linkedElement;
    const container = props.container;
    const couponKey = props.couponKey;
    const idInput = "input-calc-for-" + linkedElement;
    const coupon = betslipData.coupons[couponKey];
    
    const isEventForm = props.isEventForm;
    let event = null;
    if (isEventForm) {
    	const pal = props.pal;
    	const avv = props.avv;
    	if (coupon != null) {
    		for (var key in coupon.selections) {
    			var selection = coupon.selections[key];
    			if (selection.pal == pal && selection.avv == avv) {
    				event = selection;
    			}
    		}
    	}
    }
    
   // the amount we use to make calcs
   let amount = isEventForm && event != null? event.bets[0].amount : coupon.amountMulti;
   // the amount printed in the text field
   let printableAmount =  coupon.printableAmountMulti;
   if (isEventForm && event != null) {
	   const scomSogei = props.scomSogei;
	   const handicap = props.handicap;
	   const draw = props.draw;
	   for (let km in event.bets) {
		   const bet = event.bets[km];
   		   if (bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw == draw) {
   			   printableAmount = bet.printableAmount;
   		   }
	   }
   }
  
   const [calcShowed, toggleCalc] = useState(false);   
   
   function increaseAmount(amountCalc) {
       if (amountCalc + amount < 0) {
           return;
        }
        amountCalc += amount;
        amountCalc = getPrintableAmount(amountCalc, mult, nDec);
        setAmount(amountCalc);
   }
   
   function setAmountFromCalc(amountCalc) {
	   amountCalc = getPrintableAmount(amountCalc, mult, nDec);
	   amountCalc = amountCalc.replaceAll(charThousandBrowser, ''); // remove the thousand char from the string. In the setAmount only "decimal" is permitted
	   setAmount(amountCalc);
   }

   function setAmount(settedAmount) {
	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
	   settedAmount = getValidAmountString(settedAmount, nDec);
	   // putting the "browser decimal dot" instead of the "." used for the float type
	   let fieldTextValue = settedAmount;
	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
	   let amountCentToSet = amount; // last valid amount
	   
	   // if is number, I calculate the new amount and I keep it into the field value. 
	   // If not, I keep the field but I use the last valid amount for the calcs
	   if (isNaN(settedAmount) === false && settedAmount.length > 0) {
		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
	   }
	   
	   if (isEventForm) {
			if (event != null) {
		    	const scomSogei = props.scomSogei;
		    	const handicap = props.handicap;
		    	const draw = props.draw;
		    	for (let km in event.bets) {
		    		const bet = event.bets[km];
		    		if (bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw == draw) {
						bet.amount = amountCentToSet;
						bet.printableAmount = fieldTextValue;
		    		}
		    	}
			}
		} else {
			coupon.amountMulti = amountCentToSet;
			coupon.printableAmountMulti = fieldTextValue;
		}
		betslipContext.setBetslipData(betslipData, null, true);
	}
   
    function addChar(symb) {
    	symb = symb + '';
    	let amountString = printableAmount + '';
    	if (printableAmount === '0') {
    		amountString = '';
    	}
    	amountString = amountString + symb;
    	setAmount(amountString);
    }
    
    function handleKey(e) {
    	if (e.key === 'Enter' && coupon.selectedContainer !== 'systembets') {
			if (shopContext.enabled) {
				betslipContext.purchase();
			} else {
				if (betslipContext.getPlayButtonState() === 'play') {
					betslipContext.setPlayButtonState('confirm');
				} else if (betslipContext.getPlayButtonState() === 'confirm') {
					betslipContext.purchase();
				}		
			}
    	}
    }
    
    const showAdvise = coupon.selectedContainer === 'multibets' && betslipContext.toGetBonusAdvise && betslipContext.toGetBonusAdvise.showAdvise;

    return (
        <>
            {showAdvise &&
                <div className={"adviseToReachBonusContainer"}> 
                    <span className={"iconContainer"}> <i className={"fas fa-gift"} /> </span>
                    <span className={"textContainer"}>  {betslipContext.toGetBonusAdvise.bonusAdvise} </span> 
                </div>
            }
            <div  className={"inserimento-puntata" + classIf(container === 'singlebets', 'calcSingola')}>
                <div className="d-flex align-items-center justify-content-between mb-1">
                		{
	                		betslipContext.betOptionsSectionMustBeShown()?
	                			<BetOptionsSection />
	                			:
								<>{!props.hideCalcAndLabel && <p className={"label-for-amount-input ellipsis"}>{getLabel('carrello.stake')}</p>}</>
                		}
                        
                        {conf.aikse ?
                            <div className="d-flex align-items-center">
                                <span className="inc-dec-button mr-1" onClick={() => increaseAmount(-conf.cs.imu)}>-</span>
                                <input type="text" id={idInput} onChange={e => setAmount(e.target.value + "")} onFocus={selectInputText} onKeyUp={e => handleKey(e)}
                                        className={`input-calc calcolatrice-input amount-field-coupon-${couponKey}-container-${container}`}
                                        value={printableAmount} placeholder={getLabel('carrello.puntata')} />
                                <span className="inc-dec-button ml-1" onClick={() => increaseAmount(conf.cs.imu)}>+</span>
                            </div>
                            :
                            <input type="text" id={idInput} onChange={e => setAmount(e.target.value + "")} onFocus={selectInputText} onKeyUp={e => handleKey(e)}
                                        className={`input-calc calcolatrice-input amount-field-coupon-${couponKey}-container-${container}`}
                                        value={printableAmount} placeholder={getLabel('carrello.puntata')} />
                        }
                </div>
                {conf.bak?.dsk === true &&
                    <div className="bottoni-calc">
                        {conf.bak.vls.map(a =>
                            <input key={a} type="button" onClick={() => setAmountFromCalc(a)} value={getPrintableAmount(a, mult, nDec)}  />
                        )}
                        <a onClick={() => toggleCalc(!calcShowed) } className="apri-calc bg-nero bianco bordo-tondo pointer">
                            <i className="fas fa-calculator"></i>
                        </a>
                    </div>
                }
                <div className={"calcSingola-keys margine-su-mezzo" + (calcShowed? '':' d-none')} >
                    <div className="riga-calc">
                        {BUTTONS_FIRST_ROW.map(function(value) {
                            let reactKey = 'button-calc-' + value +'-for-' + linkedElement;
                            return (
                                <button key={reactKey} 
                                        onClick={e => addChar(e.target.value)} 
                                        type="button" 
                                        value={value}>{value}</button>
                            );
                        })}
                        {/* C BUTTON */}
                        <button onClick={() => setAmount('0')} type="button" className="all-clear bg-rosso bianco" value="all-clear">C</button>
                    </div>
                    <div className="riga-calc">
                        {BUTTON_SECOND_ROW.map(function(value) {
                                let reactKey = 'button-calc-' + value +'-for-' + linkedElement;
                                return (
                                    <button key={reactKey} 
                                            onClick={e => addChar(e.target.value)} 
                                            type="button" 
                                            value={value}>{value}</button>
                                );
                        })}
                        {/* DECIMAL BUTTON */}
                        {nDec > 0 &&
                            <button onClick={e => addChar(e.target.value)} type="button" className="decimal" value={charDecimalBrowser}>{charDecimalBrowser}</button>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default AmountBetslipForm;